import { useContext, useState } from "react";
import { IoMdMenu } from "react-icons/io";
import { RiCustomerService2Line } from "react-icons/ri";
import "./navbar.css";
import { MyContext } from "../../context/context";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { IoPower } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";

const Navbar = () => {
  const {
    isSidebarOpen,
    setIsSidebarOpen,
    setShowHelpDesk,
    setShowSubmissionForm,
    setToggleAdminTab,
    isAdminTabActive,
  } = useContext(MyContext);
  const navigate = useNavigate();

  const [activeGC, setActiveGC] = useState(() => {
    const value = JSON.parse(sessionStorage.getItem("activeGC"));
    if (value) {
      return value;
    }
    return "";
  });

  const handleLogout = () => {
    Cookies.remove("token");
    localStorage.clear("student");
    sessionStorage.clear();
    navigate("/", { replace: true }, 0);
  };

  const handleGCClick = (gc) => {
    setActiveGC(gc);
    sessionStorage.setItem("activeGC", JSON.stringify(gc));

    // Close sidebar on mobile after selection
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <button
          className="menu-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <IoMdMenu />
        </button>
        <Link to={"/course"} className="item-link">
          <div
            className="logo-section"
            onClick={() => {
              handleGCClick("");
            }}
          >
            {/* <h1>IBIX Student Portal</h1> */}
            <img
              src="https://iqteche.in/static/media/wl_client_images/2d65766bae1c490c9cec775f6cc83ea9.png"
              alt="site logo"
              className="site-logo"
            />

            <h1>Student Learning Hub</h1>
          </div>
        </Link>
      </div>
      <div className="header-right">
        {/* Action Buttons */}
        <div className="header-actions">
          <button
            className="help-desk-btn"
            onClick={() => setShowHelpDesk(true)}
          >
            <span className="help-icon">
              <RiCustomerService2Line />
            </span>
            <span className="btn-text">Help Desk</span>
          </button>

          {/* <button
            className="project-submit-btn"
            onClick={() => setShowSubmissionForm(true)}
          >
            <span className="submit-icon">📤</span>
            <span
              className="btn-text"
              onClick={() => setShowSubmissionForm(true)}
            >
              Submit Project
            </span>
          </button> */}

          <Link to={"/profile/project-submissions"} className="profile-link">
            <button
              className="help-desk-btn"
              onClick={() => {
                setToggleAdminTab(true);
              }}
            >
              <span className="help-icon">
                <FaUserCircle />
              </span>
              <span className="btn-text">My Profile</span>
            </button>
          </Link>

          <button className="help-desk-btn logout-btn" onClick={handleLogout}>
            <span className="help-icon">
              <IoPower />
            </span>
            <span className="btn-text ">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
